/*
 * @Description: 结算单管理
 * @Author: 杨志航
 * @Date: 2026-05-14 09:59:34
 */
const billManage = {
  // 结算方式列表
  getSettlementMethodList: {
    url: '/fortune/SettlementMethod/list',
    method: 'get'
  },
  // 结算方式导入
  importSettlementMethod: {
    url: '/fortune/SettlementMethod/import',
    method: 'post'
  },
  // 结算方式导出
  getSettlementMethodExportTpl: {
    url: '/fortune/SettlementMethod/GetExportTpls',
    method: 'get'
  },
  exportSettlementMethod: {
    url: '/fortune/SettlementMethod/Export',
    method: 'post'
  },
  getSettlementMethodTplItems: {
    url: '/fortune/SettlementMethod/GetExportFields',
    method: 'get'
  },
  saveSettlementMethodLevelTpl: {
    url: '/fortune/SettlementMethod/SaveExportTpls',
    method: 'post'
  },
  // 客户结算单列表
  getSettlementOrderList: {
    url: '/fortune/SettlementOrder/getList',
    method: 'get'
  },
  // 客户确认
  settlementOrderConfirm: {
    url: '/fortune/SettlementOrder/confirm',
    method: 'post'
  },
  // 客户结算单审批配置列表
  getSettlementConfigList: {
    url: '/fortune/SettlementConfig/getList',
    method: 'get'
  },
  // 导入审批配置
  importSettlementConfig: {
    url: '/fortune/SettlementConfig/import',
    method: 'post'
  },
  // 结算单审批详情
  getSettlementOrderDetail: {
    url: '/fortune/SettlementOrder/getDetail',
    method: 'get'
  },
  // 结算单审批
  approveSettlementOrder: {
    url: '/fortune/SettlementOrder/approve',
    method: 'post'
  },
  // 结算单还款数据
  getSettlementOrderRepaymentData: {
    url: '/fortune/SettlementOrder/getRepaymentData',
    method: 'get'
  },
  // 结算单还款
  repaymentSettlementOrder: {
    url: '/fortune/SettlementOrder/Repayment',
    method: 'post'
  },
  // 内部结算列表  
  getInternalSettlementList: {
    url: '/fortune/internalSettlement/list',
    method: 'get'
  },
  // 内部结算编辑结算价
  getInternalSettlementPercent: {
    url: '/fortune/internalSettlement/setPercent',
    method: 'post'
  },
  // 内部结算结算记录
  getInternalSettlementHistory: {
    url: '/fortune/internalSettlement/history',
    method: 'get'
  },
  // 内部结算导入结算
  getImportPercentImportExcel: {
    url: '/fortune/internalSettlement/importPercent',
    method: 'post'
  },
  // 内部结算导出
  getInternalSettlementExportTpl: {
    url: '/fortune/internalSettlement/GetExportTpls',
    method: 'get'
  },
  getInternalSettlementTplItems: {
    url: '/fortune/internalSettlement/GetExportFields',
    method: 'get'
  },
  getInternalSettlementSaveExportTpls: {
    url: '/fortune/internalSettlement/SaveExportTpls',
    method: 'post'
  },
  getInternalSettlementExport: {
    url: '/fortune/internalSettlement/Export',
    method: 'post'
  },
  // 根据名称获取直销或者代理商id
  getOaIdByClientName: {
    url: '/fortune/SettlementOrder/GetOaIdByClientName',
    method: 'get'
  },
}

export default billManage